module.exports = __webpack_public_path__ + "img/web-pic.783e58bd.png";